import { render, staticRenderFns } from "./AddWheatTypeModal.vue?vue&type=template&id=2fd06e68&"
import script from "./AddWheatTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddWheatTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports